import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import 'dayjs/locale/pl';
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import { Locale } from '../context/LanguageContext';

dayjs.extend(localeData);

const localeMap: Record<Locale, string> = {
  'pl-PL': 'pl',
  'en-EN': 'en',
  'de-DE': 'de'
};

export const configureDayjsLocale = (locale: Locale): void => {
  const dayjsLocale = localeMap[locale];
  dayjs.locale(dayjsLocale);
};

export const getCurrentDayjsLocale = (locale: Locale): string => {
  return localeMap[locale];
}; 